import React from 'react'
import MailchimpSubscribe from 'react-mailchimp-subscribe'
import { mailchimpUrl } from '../util/constants'

const NewsletterFormBody = ({ subscribe, status, message }) => {
  let input
  const onSubmit = (e) => {
    e.preventDefault()
    if (input && input.value.indexOf('@') > -1) {
      subscribe({ EMAIL: input.value })
    }
  }
  const showInputs = !status || status === 'error'
  return (
    <form className={`newsletter-form ${status}`} onSubmit={onSubmit}>
      {status === 'sending' && <div>Subscribing...</div>}
      {status === 'success' && (
        <div>Success! Check your email to confirm your subscription.</div>
      )}
      {showInputs && (
        <input
          ref={(node) => (input = node)}
          name="email"
          type="email"
          placeholder="Enter your email"
        />
      )}
      {showInputs && <button>Sign Up for Our Newsletter</button>}
    </form>
  )
}

const NewsletterForm = () => (
  <MailchimpSubscribe url={mailchimpUrl} render={NewsletterFormBody} />
)

export default NewsletterForm
